import { formatTimeWithTimezone } from "@src/appV2/redesign/utils/formatTimeWithTimezone";
import { isSameMinute } from "date-fns";

interface GetAutoMessageToFacilityParams {
  selectedEta: Date;
  shiftStartTime: Date;
  workplaceTimezone: string;
}

export function getAutoMessageToFacility(params: GetAutoMessageToFacilityParams): string {
  const { selectedEta, shiftStartTime, workplaceTimezone } = params;
  const formattedTime = formatTimeWithTimezone(selectedEta, workplaceTimezone, false);
  const isOnTime = isSameMinute(selectedEta, shiftStartTime);

  if (isOnTime) {
    return `I will be arriving to this shift on time at ${formattedTime}`;
  }

  return `I will be arriving to this shift at ${formattedTime}`;
}
